package com.karawek.core.ui.theme

import androidx.compose.material3.ColorScheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme

fun CoreColorScheme.toMaterialColorScheme(
    isDark: Boolean,
): ColorScheme =
    if (isDark) {
        darkColorScheme(
            primary = primary,
            onPrimary = onPrimary,
            secondary = secondary,
            onSecondary = onSecondary,
            background = background,
            onBackground = onBackgroundStrong,
            surface = surface,
            surfaceVariant = surfaceVariant,
            onSurface = textPrimary,
            onSurfaceVariant = textSecondary,
            outline = borderStrong,
            outlineVariant = divider,
            error = error,
            onError = onError,
        )
    } else {
        lightColorScheme(
            primary = primary,
            onPrimary = onPrimary,
            secondary = secondary,
            onSecondary = onSecondary,
            background = background,
            onBackground = onBackgroundStrong,
            surface = surface,
            surfaceVariant = surfaceVariant,
            onSurface = textPrimary,
            onSurfaceVariant = textSecondary,
            outline = borderStrong,
            outlineVariant = divider,
            error = error,
            onError = onError,
        )
    }
